// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactAria from "react-aria";
import * as JsxRuntime from "react/jsx-runtime";

let circumference = 2 * 15.5 * Math.PI;

let dasharray = Math.round(circumference - 2);

let make = React.memo(props => {
  let __ariaLabel = props.ariaLabel;
  let __color = props.color;
  let __size = props.size;
  let progressRatio = props.value;
  let size = __size !== undefined ? __size : 12;
  let color = __color !== undefined ? __color : "#25243A";
  let ariaLabel = __ariaLabel !== undefined ? __ariaLabel : "progress-pie-icon";
  let percent = Math.round(progressRatio * 100);
  let match = ReactAria.useProgressBar({
    value: percent,
    "aria-label": ariaLabel
  });
  let offset = Math.round(circumference * (1 - progressRatio));
  let newrecord = {...match.progressBarProps};
  return JsxRuntime.jsxs("svg", (newrecord.viewBox = "0 0 100 100", newrecord.width = size.toString(), newrecord.height = size.toString(), newrecord.children = [
    JsxRuntime.jsx("circle", {
      role: "presentation",
      cx: "50",
      cy: "50",
      fill: "transparent",
      r: (15.5).toString(),
      stroke: color,
      strokeDasharray: dasharray.toString() + `px`,
      strokeDashoffset: offset.toString() + `px`,
      strokeLinecap: "butt",
      strokeWidth: "31",
      transform: "rotate(-90 50 50)"
    }),
    JsxRuntime.jsx("path", {
      role: "presentation",
      d: "M 90 49.998 C 90 27.91 72.09 10 50.001 10 C 27.911 10 10 27.91 10 49.998 C 10 72.09 27.911 90 50.001 90 C 72.09 90 90 72.09 90 49.998 Z M 100 49.998 C 100 77.619 77.622 100 50.001 100 C 22.393 100 0 77.619 0 49.998 C 0 22.389 22.393 0 50.001 0 C 77.622 0 100 22.389 100 49.998 Z",
      fill: color
    })
  ], newrecord));
});

export {
  make,
}
/* circumference Not a pure module */
